module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appHead",
    class: {
      dark: _vm.isLives
    }
  }, [_c('div', {
    staticClass: "head1"
  }, [(_vm.backVisible) ? _c('span', [_c('a', {
    staticClass: "icon icon-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goBack
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLives) ? _c('div', {
    staticClass: "ifuyin"
  }, [_c('img', {
    attrs: {
      "src": "static/logo-icon.png"
    }
  }), _vm._v("一起看-福音影视网 iFUYIN.COM\n    ")]) : _c('div', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.isLives) ? _c('div', {
    staticClass: "head2"
  }, [_c('a', {
    attrs: {
      "href": "/short/index.html?#/short"
    }
  }, [_vm._v("微视频")]), _vm._v(" "), _c('i'), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "live"
  }, [_vm._v("一起看"), _c('label', [_vm._v("直播")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7de8066","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppHead.vue
// module id = 343
// module chunks = 0